import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, mode, Text, useColorMode, useToast } from '@abb/uikit';
import { services } from 'config/services';
import { az, enGB as en, ru } from 'date-fns/locale';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useDependencies } from 'hooks';
import { generateUrl } from 'modules/Layout/utils/generateUrl';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InfoIconBold from 'shared-components/icons/InfoIconBold';
import NotificationLogoIcon from 'shared-components/icons/NotificationLogoIcon';
import { mutate } from 'swr';
dayjs.extend(relativeTime);
export function NotificationItem(param) {
    let { notification, onDetailModalOpen } = param;
    const { colorMode } = useColorMode();
    const locales = {
        en,
        az,
        ru
    };
    const navigate = useNavigate();
    const { languageService, httpClient } = useDependencies();
    const toast = useToast();
    const { t } = useTranslation('common');
    const [isRead, setIsRead] = React.useState(notification.read);
    const handleRead = async (notificationId)=>{
        setIsRead(true);
        const url = notificationId && `${services.notification_ms}/user/notifications/WEB/${notificationId}`;
        try {
            await httpClient.put(url, notificationId);
            mutate([
                `${services.notification_ms}/user/notifications/WEB`,
                languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage.toLocaleUpperCase()
            ]);
        } catch (e) {
            toast({
                title: t('notifications.system'),
                position: 'top',
                status: 'error',
                duration: 6000,
                isClosable: true,
                id: 'emptyFields'
            });
        }
    };
    const handleOpen = (notification)=>{
        if (notification.type === 'INFO') {
            onDetailModalOpen();
        } else {
            var _notification_deepLinkData, _notification_deepLinkData1, _notification_deepLinkData2;
            (((_notification_deepLinkData = notification.deepLinkData) === null || _notification_deepLinkData === void 0 ? void 0 : _notification_deepLinkData.module) || ((_notification_deepLinkData1 = notification.deepLinkData) === null || _notification_deepLinkData1 === void 0 ? void 0 : _notification_deepLinkData1.moduleType) || ((_notification_deepLinkData2 = notification.deepLinkData) === null || _notification_deepLinkData2 === void 0 ? void 0 : _notification_deepLinkData2.action)) && navigate(generateUrl(notification.deepLinkData.module, notification.deepLinkData.moduleType, notification.deepLinkData.action), {
                replace: true
            });
        }
    };
    return /*#__PURE__*/ _jsx(Box, {
        onClick: ()=>{
            handleOpen(notification);
            if (!isRead) {
                handleRead(notification.id);
            }
        },
        overflowX: "hidden",
        borderColor: mode('blackAlpha.100', 'whiteAlpha.200')({
            colorMode
        }),
        children: /*#__PURE__*/ _jsxs(Flex, {
            py: 3,
            children: [
                (notification === null || notification === void 0 ? void 0 : notification.type) === 'INFO' ? /*#__PURE__*/ _jsx(Flex, {
                    justifyContent: "center",
                    align: "center",
                    mr: "8px",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    p: "4px",
                    backgroundColor: "#FEEBCB",
                    children: /*#__PURE__*/ _jsx(InfoIconBold, {
                        color: "#ED8936",
                        size: "16px"
                    })
                }) : /*#__PURE__*/ _jsx(Flex, {
                    justifyContent: "center",
                    align: "center",
                    mr: "8px",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    p: "6px 4px 4px 6px",
                    backgroundColor: "blue.100",
                    children: /*#__PURE__*/ _jsx(NotificationLogoIcon, {
                        size: "18px",
                        color: "#1D6FB6"
                    })
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    w: "100%",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            w: "100%",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    fontWeight: 600,
                                    noOfLines: [
                                        1,
                                        2
                                    ],
                                    wordBreak: "break-word",
                                    fontSize: "16px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    w: "200px",
                                    mb: 1,
                                    color: mode('gray.900', 'white')({
                                        colorMode
                                    }),
                                    children: notification.title
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    w: "6px",
                                    h: "6px",
                                    borderRadius: "99px",
                                    m: 2,
                                    bg: !(notification === null || notification === void 0 ? void 0 : notification.read) ? 'red' : 'gray'
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "14px",
                            noOfLines: [
                                1,
                                2
                            ],
                            wordBreak: "break-word",
                            fontWeight: 500,
                            mb: 1,
                            color: mode('gray.900', 'white')({
                                colorMode
                            }),
                            children: notification.content
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "14px",
                            color: mode('gray.900', 'white')({
                                colorMode
                            }),
                            children: dayjs(`${notification.date} ${notification.time}`).locale(locales[languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage].code).fromNow()
                        })
                    ]
                })
            ]
        })
    }, notification.id);
}
